import React from "react";

import clsx from "clsx";

import metricDecreasingTrend from "@assets/metric-decreasing-trend.png";
import metricIncreasingTrend from "@assets/metric-increasing-trend.png";

interface Props {
  isDisabled?: boolean;
  value?: boolean;
  onChange?: (value: boolean) => void;
}

export const NegativeTrendCheckbox = ({
  isDisabled,
  value = false,
  onChange,
}: Props) => (
  <div
    className={clsx(
      { "text-gray pointer-events-none": isDisabled },
      "text-xs pt-1 flex items-center space-x-2 cursor-pointer",
    )}
  >
    <span>Display increasing trends as:</span>
    <div className="flex items-center space-x-2">
      <span
        className="flex items-center space-x-2 mr-2"
        onClick={() => onChange?.(false)}
      >
        <input
          className={clsx({ "cursor-pointer": !isDisabled })}
          type="radio"
          disabled={isDisabled}
          value="false"
          checked={value === false}
          onChange={() => null}
        />
        <label className="my-0.5 cursor-pointer">Green (default)</label>
        <img
          className="w-10"
          src={metricIncreasingTrend}
          alt="Increasing trend"
        />
      </span>
      <span
        className="flex items-center space-x-2"
        onClick={() => onChange?.(true)}
      >
        <input
          className={clsx({ "cursor-pointer": !isDisabled })}
          type="radio"
          disabled={isDisabled}
          value="true"
          checked={value === true}
          onChange={() => null}
        />
        <label className="my-0.5 cursor-pointer">Red (e.g. CAC)</label>
        <img
          className="w-10"
          src={metricDecreasingTrend}
          alt="Decreasing trend"
        />
      </span>
    </div>
  </div>
);
